import React from 'react'

const SubscriptionIcon = () => {
    return (
        <div><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.6666 4.1665H3.33329C2.41282 4.1665 1.66663 4.9127 1.66663 5.83317V14.1665C1.66663 15.087 2.41282 15.8332 3.33329 15.8332H16.6666C17.5871 15.8332 18.3333 15.087 18.3333 14.1665V5.83317C18.3333 4.9127 17.5871 4.1665 16.6666 4.1665Z" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1.66663 8.3335H18.3333" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        </div>
    )
}

export default SubscriptionIcon